<gp-modal gp-modal="blockingErrorResolutionModal" #blockingErrorResolutionModal [closable]="false">
  <div class="gp-modal-title">
    {{'FORM_GENERATOR.BLOCKING_ERROR.title' | translate}}
  </div>
  <form novalidate class="gp-modal-body clearfix">

    <p>
      {{ 'FORM_GENERATOR.BLOCKING_ERROR_FIX.following_error_appeared' | translate }}
      <b>"{{ groupZoneDescriptor?.transId | translate }}"</b>
      {{ 'FORM_GENERATOR.BLOCKING_ERROR_FIX.when_you_modified' | translate }}
      <b>"{{ zoneDescriptor?.transId | translate }}"</b>.
    </p>

    <gp-message type="danger" role="alert"
                *ngIf="sanitizedBlockingErrors && sanitizedBlockingErrors.length">
      <ul class="errors-list" *ngFor="let error of sanitizedBlockingErrors">
        <li class="errors-list-item">
          <span class="error-message">
            <ng-container *ngIf="error.errorMessage.zone; else defaultTemplate">
              {{ 'FORMS.VALIDATORS.' + error.errorMessage.text | translate: error.errorMessage.additionalValues }}
            </ng-container>
            <ng-template #defaultTemplate>
              {{ 'FORM_GENERATOR.ERRORS.' + error.errorMessage.text | translate: error.errorMessage.additionalValues }}
            </ng-template>
          </span>
        </li>
      </ul>
    </gp-message>

    <p>
      <b>{{'FORM_GENERATOR.BLOCKING_ERROR_FIX.select_action' | translate}}</b>
    </p>
  </form>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button" class="btn btn-dark" (click)="backToEditMode()">
          {{ 'FORM_GENERATOR.BLOCKING_ERROR_FIX.back_edit_mode' | translate }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="cancelChange()">
          {{ 'FORM_GENERATOR.BLOCKING_ERROR_FIX.cancel_change' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
